import React from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import * as S from './PaymentMethodDisplay.styles'
import { PaymentInstrument } from '@/pages/checkout/partials/ConfirmationOrder.types'

const PaymentMethodTypeGiftCard = ({
  className = '',
  paymentInstrument
}: {
  className?: string
  paymentInstrument: PaymentInstrument
}) => {
  const { formatMessage } = useIntl()

  return (
    <div className={twMerge(S.PaymentMethodDisplayWrapper, className)}>
      <div className={S.PaymentMethodDisplayContentWrapper}>
        <div>
          {formatMessage({
            id: 'msp.checkout.confirmation.paymentMethod.giftCard',
            defaultMessage: 'Gift Card'
          })}
        </div>
        <div>{paymentInstrument?.maskedGiftCertificateCode}</div>
      </div>
    </div>
  )
}

export default PaymentMethodTypeGiftCard
